// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(12345678), 5000);
//require("component-responsive-frame/child");

import Sidechain from '@nprapps/sidechain';
const guest = Sidechain.registerGuest({ sentinel: 'st' });

guest.sendMessage({
  type: 'analytics',
  eventCategory: 'interaction',
  eventAction: 'click',
  eventLabel: 'etc'
})

document.querySelectorAll("button").forEach(el => el.addEventListener('click', () => {
  document.querySelectorAll("button").forEach(el => el.classList.remove("selected"));
  document.querySelectorAll(".block").forEach(el => el.classList.remove("selected"));
  el.classList.add('selected');
  let grade = el.innerText;
  document.querySelector(`.block[data-grade='${grade}']`).classList.add("selected");
}));